<template>
    <orders-table :title="title" :orders="orders" :page="currentPage" :action="action" :column-names="columnNames" :click-event="clickEvent" badge-text="NEW" badge-variant="success"></orders-table>
</template>

<script>

import OrdersTable from '../../components/OrdersTable'
import OrderEventBus from '../../EventBus.js'

export default {
  components: {
    OrdersTable
  },
  data: function () {
    return {
      title: 'Awaiting additional payments',
      orders: {},
      currentPage: 1,
      action: "<button class='btn btn-sm btn-outline-primary'>Open Order</button>",
      columnNames: ['id', 'creationDate', 'status', 'name', 'patient', 'clinician', 'pharmacy', 'actions'],
      clickEvent: 'awaiting-additional-payments-click'
    }
  },
  mounted () {
    this.getOrders();
    OrderEventBus.$on('currentPage', (currentPage) => {
      this.currentPage = currentPage;
    });
    OrderEventBus.$on(this.clickEvent, (orderId) => {
      this.$router.push('/order/' + orderId)
    });
  },
  watch: {
    currentPage: function () {
      this.getOrders();
    }
  },
  methods: {
    getOrders () {
      this.$orderService.getAwaitingAdditionalPaymentOrders(this.currentPage - 1, 10).then(orders => {
        this.orders = orders;
      }).catch(error => {
        console.log(error);
        this.$awn.alert('There was an error getting orders');
      });
    },
  },
  beforeDestroy () {
    OrderEventBus.$off();
  }
}
</script>
